<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      :pageMode="true"
      orderBy="sequence"
      orderWay="asc"
      @filter-select="$_onFilterSelect($event)"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/industry_category";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: ["sequence", "area", "name", "updated_at", "updated_admin"],
    liveSearching: true,
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "請選擇地區",
      },
    ],
    filterProps: {},
  }),
  methods: {
    $_onFilterSelect($event) {
      this.filterProps = {
        ...$event,
      };
    },
  }
};
</script>